import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages } from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ImagesEdit from "./EditForms/ImagesEdit"; // eslint-disable-line import/no-named-as-default
import EditButton from "../shared/button/EditButton";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import {
  Wrapper,
  Slide,
  Image,
  SliderPlaceholder,
} from "./styles/slider-styles";

export class ImageSlider extends Component {
  state = {
    editImagesActive: false,
  };

  toggleEditImages = () => {
    this.setState(({ editImagesActive }) => ({
      editImagesActive: !editImagesActive,
    }));
  };

  render() {
    const { editImagesActive } = this.state;
    const { slides, currentUser, imagesFormLoading } = this.props;
    const settings = {
      dots: true,
      infinite: true,
      speed: 750,
      fade: true,
      cssEase: "linear",
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 15000,
      slidesToScroll: 1,
      arrows: false,
    };

    return (
      <Wrapper
        className="animated delay-1 fadeIn"
        editImagesActive={editImagesActive}
      >
        {editImagesActive && (
          <ImagesEdit toggleEditImages={this.toggleEditImages} />
        )}
        {imagesFormLoading && <WidgetLoading />}
        {currentUser.isRecruiter && (
          <EditButton
            onClickAction={this.toggleEditImages}
            top={8}
            right={10}
          />
        )}
        {slides.length < 1 ? (
          <SliderPlaceholder>
            <FontAwesomeIcon icon={faImages} />
          </SliderPlaceholder>
        ) : (
          <Slider {...settings}>
            {slides.map((slide) => (
              <Slide key={slide.id}>
                <Image src={slide.url} alt={`Slide ${slide.id}`} />
              </Slide>
            ))}
          </Slider>
        )}
      </Wrapper>
    );
  }
}

ImageSlider.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number, url: PropTypes.string })
  ).isRequired,
  user: PropTypes.shape({
    isRecruiter: PropTypes.bool,
    isAdmin: PropTypes.bool,
  }),
  currentUser: PropTypes.shape({
    isRecruiter: PropTypes.bool.isRequired,
  }).isRequired,
  imagesFormLoading: PropTypes.bool.isRequired,
};

ImageSlider.defaultProps = {
  user: PropTypes.isNull,
};

const mapStateToProps = (state) => ({
  slides: state.agencyProfile.profileData.slides,
  user: state.agencyProfile.profileData.user,
  currentUser: state.agencyProfile.profileData.currentUser,
  imagesFormLoading: state.agencyProfile.imagesFormLoading,
});

export default connect(mapStateToProps, {})(ImageSlider);
